import { isUndefined } from '../../../utils/isDefined';

export default function pickOptionsForStatusCell(object = {}, key) {
  if (isUndefined(object[key])) {
    return { color: '#6C757D', text: key };
  }
  return object[key];
}
